import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {onMounted, ref, watch, computed} from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationBadge',
  props: {
        count: {type: Number, default: 0},
        offset: {type: Number, default: 0},
    },
  setup(__props) {

const props = __props;

    

    const formattedCount = computed(() => {
        if (props.count > 10) {
            return '10+';
        }
        return props.count;
    });

    const badgeRef = ref<HTMLDivElement>();

    function setOffset() {
        badgeRef.value?.style.setProperty('--offset', `${props.offset}px`);
    }
    watch(() => props.offset, setOffset);

    onMounted(setOffset);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "badgeRef",
    ref: badgeRef,
    class: "notification-badge"
  }, [
    _createElementVNode("span", null, _toDisplayString(formattedCount.value), 1)
  ], 512))
}
}

})